module.exports = __webpack_public_path__ + "static/hero-913d3ae255a3de786b85ef5fba2ce50c.png";